export default __webpack_public_path__ + "./login-logo.462c59743f42b57d4a9a18259b6e7ce0.png";